<div class="breadcrumbs button-link">
  <!-- ICP VIA T1 -->
  @if (isTenableOneUser && t1_url()) {
    <a [href]="t1_url()" class="em-url">
      <app-vendor-icon class="em-icon" [svgIcon]="VendorIconsEnum.tenable"></app-vendor-icon>
      <span class="name ellipsis" [matTooltip]="tenable_workspace">
        {{ tenable_workspace }}
      </span>
    </a>
    <app-icon [svgIcon]="IconsEnum.chevron_right"></app-icon>
  }
  <!-- ICP VIA EM -->
  @if (iemService.isIcpViewInEm()) {
    <a [href]="emUrl" class="em-url">
      <app-icon class="em-icon" [svgIcon]="IconsEnum.tenable_em"></app-icon>
      <span class="name ellipsis" [matTooltip]="emName$ | async">
        {{ emName$ | async }}
      </span>
    </a>
    <app-icon [svgIcon]="IconsEnum.chevron_right"></app-icon>
  }
  <!-- ICP -->
  <span class="name ellipsis" [matTooltip]="icpName$ | async">
    {{ icpName$ | async }}
  </span>
